var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column text-center align-center py-5"},[_c('v-icon',{attrs:{"x-large":"","color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]),_c('p',{staticClass:"mt-3 subtitle-2"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }